// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { AttributeId } from "./attribute-id";
import { MonitorMode, unionToMonitorMode, unionListToMonitorMode } from "./monitor-mode";
import {
  MonitoringParameters,
  MonitoringParametersT,
  verifyMonitoringParameters,
} from "./monitoring-parameters";
import { NodeId, NodeIdT, verifyNodeId } from "./node-id";
import { PollMode, PollModeT, verifyPollMode } from "./poll-mode";
import { SubscribeMode, SubscribeModeT, verifySubscribeMode } from "./subscribe-mode";

/**
 * Per-point monitor configuration: which node, which attribute, observed how,
 * with which monitoring parameters.
 */
export class NodeMonitor implements flatbuffers.IUnpackableObject<NodeMonitorT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): NodeMonitor {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsNodeMonitor(bb: flatbuffers.ByteBuffer, obj?: NodeMonitor): NodeMonitor {
    return (obj || new NodeMonitor()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsNodeMonitor(
    bb: flatbuffers.ByteBuffer,
    obj?: NodeMonitor,
  ): NodeMonitor {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new NodeMonitor()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  nodeId(obj?: NodeId): NodeId | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new NodeId()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  modeType(): MonitorMode {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : MonitorMode.NONE;
  }

  mode<T extends flatbuffers.Table>(obj: any): any | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.__union(obj, this.bb_pos + offset) : null;
  }

  /**
   * Attribute to monitor (defaults to Value).
   */
  attributeId(): AttributeId {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : AttributeId.Value;
  }

  /**
   * Optional per-item monitoring parameters (subscription mode).
   */
  params(obj?: MonitoringParameters): MonitoringParameters | null {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset
      ? (obj || new MonitoringParameters()).__init(
          this.bb!.__indirect(this.bb_pos + offset),
          this.bb!,
        )
      : null;
  }

  static startNodeMonitor(builder: flatbuffers.Builder) {
    builder.startObject(5);
  }

  static addNodeId(builder: flatbuffers.Builder, nodeIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, nodeIdOffset, 0);
  }

  static addModeType(builder: flatbuffers.Builder, modeType: MonitorMode) {
    builder.addFieldInt8(1, modeType, MonitorMode.NONE);
  }

  static addMode(builder: flatbuffers.Builder, modeOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, modeOffset, 0);
  }

  static addAttributeId(builder: flatbuffers.Builder, attributeId: AttributeId) {
    builder.addFieldInt32(3, attributeId, AttributeId.Value);
  }

  static addParams(builder: flatbuffers.Builder, paramsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(4, paramsOffset, 0);
  }

  static endNodeMonitor(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // node_id
    builder.requiredField(offset, 8); // mode
    return offset;
  }

  unpack(): NodeMonitorT {
    return new NodeMonitorT(
      this.nodeId() !== null ? this.nodeId()!.unpack() : null,
      this.modeType(),
      (() => {
        const temp = unionToMonitorMode(this.modeType(), this.mode.bind(this));
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })(),
      this.attributeId(),
      this.params() !== null ? this.params()!.unpack() : null,
    );
  }

  unpackTo(_o: NodeMonitorT): void {
    _o.nodeId = this.nodeId() !== null ? this.nodeId()!.unpack() : null;
    _o.modeType = this.modeType();
    _o.mode = (() => {
      const temp = unionToMonitorMode(this.modeType(), this.mode.bind(this));
      if (temp === null) {
        return null;
      }
      return temp.unpack();
    })();
    _o.attributeId = this.attributeId();
    _o.params = this.params() !== null ? this.params()!.unpack() : null;
  }

  unpackFields(...fields: string[]): NodeMonitorT {
    const t = new NodeMonitorT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("node_id")) {
      t.nodeId = this.nodeId() !== null ? this.nodeId()!.unpack() : null;
    }
    if (fieldSet.has("mode_type")) {
      t.modeType = this.modeType();
    }
    if (fieldSet.has("mode")) {
      t.mode = (() => {
        const temp = unionToMonitorMode(this.modeType(), this.mode.bind(this));
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })();
    }
    if (fieldSet.has("attribute_id")) {
      t.attributeId = this.attributeId();
    }
    if (fieldSet.has("params")) {
      t.params = this.params() !== null ? this.params()!.unpack() : null;
    }
    return t;
  }
}

export class NodeMonitorT implements flatbuffers.IGeneratedObject {
  constructor(
    public nodeId: NodeIdT | null = null,
    public modeType: MonitorMode = MonitorMode.NONE,
    public mode: PollModeT | SubscribeModeT | null = null,
    public attributeId: AttributeId = AttributeId.Value,
    public params: MonitoringParametersT | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.nodeId === null || this.nodeId === undefined) {
      throw new Error('Required field "node_id" is not set');
    }
    if (this.mode === null || this.mode === undefined) {
      throw new Error('Required field "mode" is not set');
    }
    const nodeId = this.nodeId !== null ? this.nodeId!.pack(builder) : 0;
    const mode = builder.createObjectOffset(this.mode);
    const params = this.params !== null ? this.params!.pack(builder) : 0;

    NodeMonitor.startNodeMonitor(builder);
    NodeMonitor.addNodeId(builder, nodeId);
    NodeMonitor.addModeType(builder, this.modeType);
    NodeMonitor.addMode(builder, mode);
    NodeMonitor.addAttributeId(builder, this.attributeId);
    NodeMonitor.addParams(builder, params);

    return NodeMonitor.endNodeMonitor(builder);
  }

  clone(): NodeMonitorT {
    const obj = new NodeMonitorT();
    obj.nodeId = this.nodeId !== null ? this.nodeId!.clone() : null;
    obj.modeType = this.modeType;
    obj.mode =
      this.mode !== null && typeof (this.mode as any).clone === "function"
        ? (this.mode as any).clone()
        : this.mode;
    obj.attributeId = this.attributeId;
    obj.params = this.params !== null ? this.params!.clone() : null;
    return obj;
  }

  equals(other: NodeMonitorT): boolean {
    if (this.nodeId !== null && other.nodeId !== null) {
      if (!this.nodeId!.equals(other.nodeId!)) return false;
    } else if (this.nodeId !== other.nodeId) return false;
    if (this.modeType !== other.modeType) return false;
    if (this.mode !== null && other.mode !== null) {
      if (typeof (this.mode as any).equals === "function") {
        if (!(this.mode as any).equals(other.mode)) return false;
      } else if (this.mode !== other.mode) return false;
    } else if (this.mode !== other.mode) return false;
    if (this.attributeId !== other.attributeId) return false;
    if (this.params !== null && other.params !== null) {
      if (!this.params!.equals(other.params!)) return false;
    } else if (this.params !== other.params) return false;
    return true;
  }
}

export function verifyNodeMonitor(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyNodeId(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "node_id");
    verifier.checkScalarField(tablePos, 6, 1);
    verifier.checkUnionConsistency(tablePos, 6, 8, "mode");
    {
      const pos = verifier.checkOffsetField(tablePos, 8);
      if (pos !== 0) {
        const uType = verifier.readFieldUint8(tablePos, 6);
        switch (uType) {
          case 1: // SubscribeMode
            {
              const o = verifier.readInt32(pos);
              verifySubscribeMode(verifier, pos + o);
            }
            break;
          case 2: // PollMode
            {
              const o = verifier.readInt32(pos);
              verifyPollMode(verifier, pos + o);
            }
            break;
        }
      }
    }
    verifier.checkRequiredField(tablePos, 8, "mode");
    verifier.checkScalarField(tablePos, 10, 4);
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 12);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyMonitoringParameters(verifier, fieldPos + tableOffset);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
